export default "__VITE_ASSET__DcPAiEQw__"